/**
 * @desc: 人工复核
 * @created: 2020/4/30
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http';

// 法院公告检索
export const getAnalysisAffichIndex = params => {
  return request.get('/manualReview/correlationAnalysisAffich', params)
}

// 法院公告详情
export const getAnalysisAffichDetail = params => {
  return request.get('/manualReview/correlationAnalysisAffichDetail', params)
}

// 判决文书检索列表
export const getAnalysisJudgmentIndex = params => {
  return request.get('/manualReview/AnalysisJudgmentList', params)
}

// 获取判决文书详情
export const getAnalysisJudgmentDetail = params => {
  return request.get('/manualReview/AnalysisJudgmentDetail', params)
}

// 判决文书列表详细
export const getAnalysisJudgmentIndexDetail = params => {
  return request.get('/manualReview/AnalysisJudgmentListDetail', params)
}

// 获取失信被执行人详细
export const getDisPersonDetail = params => {
  return request.get('/manualReview/disPersonDetail', params)
}

// 获取失信被执行人列表 (简略)
export const getDisPersonIndex = params => {
  return request.get('/manualReview/disPersonList', params)
}
